/* Suprimal contact page: topics, live validation, drafts, reply-by date, copy email, success state. */
(function () {
  'use strict';
  var DRAFT = 'sp_ct_draft', SENT = 'sp_ct_sent';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(root) {
    if (root.__spCt) return;
    root.__spCt = true;
    var form = root.querySelector('[data-sp-ct-form]');
    var min = parseInt(root.getAttribute('data-min'), 10) || 20;

    // Reply-by date: add N business days, skipping weekends
    var by = root.querySelector('[data-sp-ct-by]');
    if (by) {
      var days = parseInt(root.getAttribute('data-reply-days'), 10) || 2;
      var d = new Date();
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      var added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
      var lang = document.documentElement.lang || 'en';
      var label;
      try { label = d.toLocaleDateString(lang, { weekday: 'long', month: 'short', day: 'numeric' }); } catch (e) { label = d.toDateString(); }
      by.innerHTML = 'Write today, hear back by <b></b>';
      by.querySelector('b').textContent = label;
      by.hidden = false;
    }

    // Copy email
    var toast = root.querySelector('[data-sp-ct-toast]'), tToast;
    function showToast() {
      if (!toast) return;
      clearTimeout(tToast);
      toast.hidden = false;
      toast.getBoundingClientRect();
      toast.classList.add('is-in');
      tToast = setTimeout(function () { toast.classList.remove('is-in'); tToast = setTimeout(function () { toast.hidden = true; }, 400); }, 2200);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-sp-ct-copy]'), function (btn) {
      var lab = btn.querySelector('[data-sp-ct-copy-label]'), tBtn;
      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-sp-ct-copy');
        function done() {
          btn.classList.add('is-copied');
          if (lab) lab.textContent = 'Copied';
          showToast();
          clearTimeout(tBtn);
          tBtn = setTimeout(function () { btn.classList.remove('is-copied'); if (lab) lab.textContent = 'Copy'; }, 2200);
        }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); done(); } catch (e) { window.location.href = 'mailto:' + text; }
          ta.remove();
        }
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(done, fallback); else fallback();
      });
    });

    if (!form) return;
    var fields = root.querySelector('[data-sp-ct-fields]');
    var done = root.querySelector('[data-sp-ct-done]');
    var radios = Array.prototype.slice.call(form.querySelectorAll('.sp-ct-topic__input'));
    var tips = Array.prototype.slice.call(form.querySelectorAll('[data-tip]'));
    var orderWrap = form.querySelector('[data-sp-ct-order]');
    var email = form.querySelector('[name="contact[email]"]');
    var name = form.querySelector('[name="contact[name]"]');
    var order = form.querySelector('[name="contact[Order number]"]');
    var phone = form.querySelector('[name="contact[phone]"]');
    var msg = form.querySelector('[name="contact[body]"]');
    var count = form.querySelector('[data-sp-ct-count]');
    var saved = form.querySelector('[data-sp-ct-saved]');
    var bar = root.querySelector('[data-sp-ct-progress]');
    var submit = form.querySelector('[data-sp-ct-submit]');
    var alertBox = form.querySelector('[data-sp-ct-alert]');
    var basePh = msg ? (msg.getAttribute('data-ph') || msg.getAttribute('placeholder') || '') : '';

    function fieldOf(el) { return el ? el.closest('.sp-ct-field') : null; }
    function checkEmail(show) {
      if (!email) return true;
      var v = email.value.trim(), ok = EMAIL.test(v);
      mark(email, ok, show && (v.length > 0 || show === 'force'));
      return ok;
    }
    function checkMsg(show) {
      if (!msg) return true;
      var ok = msg.value.trim().length >= min;
      mark(msg, ok, show && (msg.value.trim().length > 0 || show === 'force'));
      return ok;
    }
    function checkPhone(show) {
      if (!phone) return true;
      var f = fieldOf(phone), req = f && f.hasAttribute('data-required');
      var v = phone.value.trim(), ok = req ? /[0-9]{6,}/.test(v.replace(/\D/g, '')) : (!v || /[0-9]{6,}/.test(v.replace(/\D/g, '')));
      mark(phone, ok, show && (v.length > 0 || show === 'force'));
      return ok;
    }
    function mark(el, ok, show) {
      var f = fieldOf(el);
      if (!f) return;
      f.classList.toggle('is-valid', ok && el.value.trim().length > 0);
      if (ok) { f.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); }
      else if (show) { f.classList.add('is-invalid'); el.setAttribute('aria-invalid', 'true'); }
    }

    function progress() {
      if (!bar) return;
      var steps = 0, total = 2;
      if (radios.length) { total++; if (radios.some(function (r) { return r.checked; })) steps++; }
      if (email && EMAIL.test(email.value.trim())) steps++;
      if (msg && msg.value.trim().length >= min) steps++;
      bar.style.transform = 'scaleX(' + (steps / total).toFixed(3) + ')';
    }

    function autosize() {
      if (!msg) return;
      msg.style.height = 'auto';
      msg.style.height = Math.max(150, msg.scrollHeight + 2) + 'px';
    }
    function counter() {
      if (!msg || !count) return;
      var n = msg.value.length, max = parseInt(msg.getAttribute('maxlength'), 10) || 3000;
      var t = msg.value.trim().length;
      count.textContent = t > 0 && t < min ? (min - t) + ' more to go' : n + ' / ' + max;
      count.classList.toggle('is-ok', t >= min);
    }

    function setOrder(open) {
      if (!orderWrap) return;
      orderWrap.classList.toggle('is-open', open);
      if (open) orderWrap.removeAttribute('inert'); else orderWrap.setAttribute('inert', '');
      orderWrap.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    function selectTopic(r, fromUser) {
      radios.forEach(function (x) { x.checked = x === r; });
      var key = r ? r.getAttribute('data-key') : '';
      tips.forEach(function (t) { t.hidden = t.getAttribute('data-tip') !== key; });
      setOrder(!!r && r.getAttribute('data-order') === '1');
      if (msg) msg.setAttribute('placeholder', (r && r.getAttribute('data-ph')) || basePh);
      progress();
      if (fromUser) saveDraft();
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) selectTopic(r, true); });
    });

    // Drafts (this tab only)
    var tSave;
    function saveDraft() {
      clearTimeout(tSave);
      tSave = setTimeout(function () {
        var t = radios.filter(function (r) { return r.checked; })[0];
        var data = { name: name ? name.value : '', email: email ? email.value : '', order: order ? order.value : '', phone: phone ? phone.value : '', msg: msg ? msg.value : '', topic: t ? t.getAttribute('data-key') : '' };
        if (!data.msg && !data.order && !data.topic) { store(DRAFT, null); return; }
        store(DRAFT, data);
        if (saved && msg && msg.value.trim()) { saved.hidden = false; }
      }, 500);
    }
    function restore(d) {
      if (!d) return false;
      if (name && !name.value && d.name) name.value = d.name;
      if (email && !email.value && d.email) email.value = d.email;
      if (order && !order.value && d.order) order.value = d.order;
      if (phone && !phone.value && d.phone) phone.value = d.phone;
      if (msg && !msg.value && d.msg) msg.value = d.msg;
      if (d.topic) {
        var r = radios.filter(function (x) { return x.getAttribute('data-key') === d.topic; })[0];
        if (r) selectTopic(r, false);
      }
      if (saved && d.msg) { saved.hidden = false; saved.lastElementChild.textContent = 'Draft restored'; }
      return true;
    }

    [name, email, order, phone, msg].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', function () {
        var f = fieldOf(el);
        if (el === email) checkEmail(f && f.classList.contains('is-invalid'));
        if (el === msg) { checkMsg(f && f.classList.contains('is-invalid')); counter(); autosize(); }
        if (el === phone) checkPhone(f && f.classList.contains('is-invalid'));
        if (saved && saved.lastElementChild.textContent !== 'Draft saved') saved.lastElementChild.textContent = 'Draft saved';
        progress();
        saveDraft();
      });
    });
    if (email) email.addEventListener('blur', function () { checkEmail(true); });
    if (msg) msg.addEventListener('blur', function () { checkMsg(true); });
    if (phone) phone.addEventListener('blur', function () { checkPhone(true); });

    form.addEventListener('submit', function (e) {
      var okE = checkEmail('force'), okM = checkMsg('force'), okP = checkPhone('force');
      if (!(okE && okM && okP)) {
        e.preventDefault();
        var first = form.querySelector('.is-invalid .sp-ct-field__input');
        if (first) first.focus({ preventScroll: false });
        if (submit) { submit.classList.remove('is-shake'); void submit.offsetWidth; submit.classList.add('is-shake'); }
        return;
      }
      var t = radios.filter(function (r) { return r.checked; })[0];
      store(SENT, { name: name ? name.value.trim() : '', email: email ? email.value.trim() : '', topic: t ? t.value : '' });
      form.classList.add('is-sending');
      if (submit) submit.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { form.classList.remove('is-sending'); if (submit) submit.removeAttribute('aria-busy'); } });

    // Topic from links: ?topic=returns, #contact-returns, or any on-page link to #contact-<key>
    function topicByKey(k) {
      k = (k || '').toLowerCase();
      return radios.filter(function (r) { return r.getAttribute('data-key') === k; })[0];
    }
    function goToForm(r) {
      if (done && !done.hidden) return;
      if (r) selectTopic(r, true);
      var wrap = form.closest('.sp-ct__formwrap') || form;
      wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () { var target = (r && email && !email.value) ? email : (msg || email); if (target) target.focus({ preventScroll: true }); }, reduce ? 0 : 650);
    }
    var wrapId = (form.closest('.sp-ct__formwrap') || {}).id || '';
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#contact-"]') : null;
      if (!a || a.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return;
      var r = topicByKey(a.hash.slice(9));
      if (!r && a.hash.slice(1) !== wrapId) return;
      e.preventDefault();
      goToForm(r);
      history.replaceState(null, '', a.hash);
    });

    // Initial state
    var params = new URLSearchParams(location.search);
    var hashKey = location.hash.indexOf('#contact-') === 0 ? location.hash.slice(9) : '';
    var linked = topicByKey(params.get('topic') || hashKey);

    if (done) {
      var info = load(SENT);
      store(SENT, null); store(DRAFT, null);
      if (info) {
        var nm = done.querySelector('[data-sp-ct-done-name]');
        var first = (info.name || '').split(/\s+/)[0];
        if (nm && first) nm.textContent = ', ' + first;
        var em = done.querySelector('[data-sp-ct-done-email]'), emw = done.querySelector('[data-sp-ct-done-mail]');
        if (em && emw && info.email) { em.textContent = info.email; emw.hidden = false; }
      }
      try {
        var u = new URL(location.href);
        u.searchParams.delete('contact_posted');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) {}
      var wrap = form.closest('.sp-ct__formwrap') || form;
      setTimeout(function () { wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); done.focus({ preventScroll: true }); }, 250);
      var again = done.querySelector('[data-sp-ct-again]');
      if (again) again.addEventListener('click', function () {
        done.hidden = true;
        form.reset();
        if (msg) msg.value = '';
        fields.hidden = false;
        selectTopic(null, false);
        counter(); autosize(); progress();
        var f = email && !email.value ? email : (msg || email);
        if (f) f.focus();
      });
    } else {
      if (alertBox) store(SENT, null);
      var had = restore(load(DRAFT));
      if (linked) selectTopic(linked, !had);
      if (alertBox) {
        setTimeout(function () { (form.closest('.sp-ct__formwrap') || form).scrollIntoView({ behavior: 'auto', block: 'start' }); alertBox.focus({ preventScroll: true }); }, 120);
      } else if (linked || (wrapId && location.hash === '#' + wrapId)) {
        setTimeout(function () { goToForm(null); }, 300);
      }
    }
    if (!radios.some(function (r) { return r.checked; })) setOrder(false);
    counter(); autosize(); progress();
    if (msg && msg.value.trim()) checkMsg(false);
    if (email && email.value.trim()) checkEmail(false);
  }

  // Quick-answer cards: soft light that follows the pointer
  function spotlight() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.addEventListener('pointermove', function (e) {
      var c = e.target.closest ? e.target.closest('.sp-cth-card') : null;
      if (!c) return;
      var r = c.getBoundingClientRect();
      c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      c.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-ct]'), init);
    spotlight();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-sp-ct]'); if (r) init(r); });
})();